module.exports = __webpack_public_path__ + "img/cartaz.4287630f.jpg";